import { Folder, File } from '@/types/folders/folder';
import { FolderStore } from './stores/FolderStore';
import { FileStore } from './stores/FileStore';

export class DocumentsDatabase {
  public readonly folders: FolderStore;
  public readonly files: FileStore;

  constructor() {
    this.folders = new FolderStore();
    this.files = new FileStore();
    this.initializeDefaultData();
  }

  private initializeDefaultData(): void {
    const folderMap = this.folders.initializeDefaultData();
    this.files.initializeDefaultData(folderMap);
  }

  getFolders(params?: {
    parent_id?: string;
    organization_id?: string;
    category_id?: string;
    project_id?: string;
  }): { folders: Folder[]; files: File[] } {
    return {
      folders: this.folders.getAll(params),
      files: this.files.getAll(params),
    };
  }

  deleteFolder(folderId: string): boolean {
    this.files.deleteByParentId(folderId);
    return this.folders.delete(folderId);
  }

  clear(): void {
    this.folders.clear();
    this.files.clear();
  }

  getAllFolders(): Folder[] {
    return this.folders.getAllActive();
  }

  getAllFiles(): File[] {
    return this.files.getAllActive();
  }
}

export const documentsDatabase = new DocumentsDatabase();
